<template>
  <div class="layout-box">
    <div class="app-title">
      <img src="./assets/title.png">
      <span class="app-date">{{currentTime}}</span>
    </div>
    <div class="app-content">
      <router-view />
    </div>
    <div class="menu-box">
      <div class="btn-box">
        <div class="item" v-for="item in menus" :key="item.id" @click="menuChange(item)">
          <img :class="selectedMenu === item.id ? 'selected-img' : ''" :src="selectedMenu === item.id ? item.selectedUrl : item.url">
          <div :class="selectedMenu === item.id ? 'selected-title' : ''" class="menu-title">{{item.title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  data () {
    return {
      timer: null,
      currentTime: '',
      weekName: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      menus: [
        { url: require('./assets/zhyl.png'), selectedUrl: require('./assets/zhyl-selected.png'), title: '综合一览', id: 'menu01' },
        { url: require('./assets/jcss.png'), selectedUrl: require('./assets/jcss-selected.png'), title: '基础设施', id: 'menu02' },
        { url: require('./assets/syyy.png'), selectedUrl: require('./assets/syyy-selected.png'), title: '商业运营', id: 'menu03' },
        { url: require('./assets/nysy.png'), selectedUrl: require('./assets/nysy-selected.png'), title: '能源使用', id: 'menu04' },
        { url: require('./assets/ssjk.png'), selectedUrl: require('./assets/ssjk-selected.png'), title: '实时监控', id: 'menu05' }
      ],
      selectedMenu: 'menu01'
    }
  },
  created () {
    this.getDate()
  },
  mounted () {
    this.timer = setInterval(() => {
      this.getDate()
    }, 10000)
  },
  updated () {
    const path = this.$route.path
    // this.selectedMenu =
    switch (path) {
      case '/home':
        this.selectedMenu = 'menu01'
        break
      case '/construction':
        this.selectedMenu = 'menu02'
        break
      case '/business':
        this.selectedMenu = 'menu03'
        break
      case '/energy':
        this.selectedMenu = 'menu04'
        break
      case '/security':
        this.selectedMenu = 'menu05'
        break

      default:
        break
    }
  },
  methods: {
    getDate () {
      const date = dayjs().format('YYYY年MM月DD日HH:mm')
      const week = this.weekName[dayjs().day()]
      this.currentTime = date.slice(0, 11) + ' ' + week + ' ' + date.slice(11)
    },
    menuChange (item) {
      const allowIp = '172.17'
      console.log('工具栏切换==========》' + window.location.origin)
      this.selectedMenu = item.id
      if (item.id === 'menu01') {
        this.$router.push({ path: 'home' })
      } else if (item.id === 'menu02') {
        if (window.location.origin.includes(allowIp)) {
          this.$router.push({ path: 'construction' })
        } else {
          alert('该模块不允许外网访问！')
        }
      } else if (item.id === 'menu03') {
        if (window.location.origin.includes(allowIp)) {
          this.$router.push({ path: 'business' })
        } else {
          alert('该模块不允许外网访问！')
        }
      } else if (item.id === 'menu04') {
        if (window.location.origin.includes(allowIp)) {
          this.$router.push({ path: 'energy' })
        } else {
          alert('该模块不允许外网访问！')
        }
      } else if (item.id === 'menu05') {
        if (window.location.origin.includes(allowIp)) {
          this.$router.push({ path: 'security' })
        } else {
          alert('该模块不允许外网访问！')
        }
      }
    }
  },
  destroyed () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-box {
  position: fixed;
  width: 100%;
  height: 100%;
  pointer-events: none;
  .app-title {
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('./assets/bg_top.png') no-repeat;
    background-size: 100% 100%;
    img {
      width: 852px;
      height: 70px;
    }
    .app-date {
      position: absolute;
      top: 70px;
      right: 117px;
      font-family: 'ldrfont';
      font-size: 29px;
    }
  }
  .app-content {
    position: relative;
    width: 100vw;
    height: calc(100% - 150px);
    box-sizing: border-box;
  }
  .menu-box {
    position: absolute;
    bottom: 0;
    left: 321px;
    right: 299px;
    height: 155px;
    background: url('./assets/bg_daohang.png') no-repeat;
    background-size: 100% 100%;
    pointer-events:auto;
    .btn-box {
      position: absolute;
      top: -80px;
      left: 550px;
      right: 550px;
      height: 220px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .item {
        cursor: pointer;
        img {
          width: 147px;
          height: 147px;
        }
        div {
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: normal;
          color: #78B7D5;
          font-size: 28px;
        }
        .selected-img {
          width: 184px;
          height: 184px;
        }
        .selected-title {
          color: #00FFF6;
          font-size: 36px;
          font-weight: bolder;
        }
      }
    }
  }
}
</style>
